module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Privacy Policy"}},"it":{"meta":{"title":""}},"lt":{"meta":{"title":"Privatumo politika"}},"pl":{"meta":{"title":"Polityka prywatności"}}}')
  delete Component.options._Ctor
}
